// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import computeData from '../hoc/computeData'

import * as React from 'react'

type Props = BasicProps & {
  timeout: number
};

@computeData({ includeVisible: false })
export default class Timeout extends React.PureComponent<Props> {
  static defaultProps = {
    isShow: true,
    needToSave: false
  };

  static schema: PropsSchema = [
    {
      type: 'number',
      key: 'timeout',
      title: '延迟时间'
    },
    {
      type: 'event',
      title: '成功',
      event: 'resolve'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '启动',
      name: 'start'
    }
  ];

  timer: ?number;

  componentWillUnmount () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  actionStart = () => {
    const { timeout = 0, callActions } = this.props
    this.timer = setTimeout(() => {
      callActions('resolve')
      clearTimeout(this.timer)
    }, timeout)
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/Timeout.js